import { Typography } from "@material-tailwind/react";
import { t } from "i18next";

interface OriginTypeSectionProps {
  workorder: EasyTech.Workorder;
}

export function OriginTypeSection({ workorder }: OriginTypeSectionProps) {
  /**
   * Récupère le label traduit d'un workorder origin selon la langue de l'utilisateur
   * @param workorderOrigin - WorkorderOrigin contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedOriginLabel = (workorderOrigin: EasyTech.WorkorderOrigin): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (workorderOrigin.translations && Array.isArray(workorderOrigin.translations)) {
      const translation = workorderOrigin.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return workorderOrigin.label || "";
  };

  /**
   * Récupère le label traduit d'un workorder type selon la langue de l'utilisateur
   * @param workorderType - WorkorderType contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedTypeLabel = (workorderType: EasyTech.WorkorderType): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (workorderType.translations && Array.isArray(workorderType.translations)) {
      const translation = workorderType.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return workorderType.label || "";
  };

  return (
    <>
      {workorder?.origin?.label && (
        <div className="field">
          <label>{t("common:origin")}</label>
          <Typography>{getTranslatedOriginLabel(workorder.origin)}</Typography>
        </div>
      )}

      {workorder?.type && (
        <div className="field">
          <label>{t("common:type")}</label>
          <Typography>{getTranslatedTypeLabel(workorder.type)}</Typography>
        </div>
      )}
    </>
  );
}